import { translate } from "utils/translations/translate";

const getErrorMessage = (errorMessage: string): string => {
  const syntaxMatch = /Invalid syntax '(?<tag>[^']+)'/u.exec(errorMessage);
  if (syntaxMatch?.groups) {
    return translate.t("validations.invalidMarkdown.syntax", {
      tag: syntaxMatch.groups.tag,
    });
  }

  const attributeMatch =
    /Invalid attribute '(?<attr>[^']+)' with value '(?<value>[^']+)'/u.exec(
      errorMessage,
    );
  if (attributeMatch?.groups) {
    return translate.t("validations.invalidMarkdown.attribute", {
      attr: attributeMatch.groups.attr,
      value: attributeMatch.groups.value,
    });
  }

  const tagMatch = /Invalid tag '(?<tag>[^']+)'/u.exec(errorMessage);
  if (tagMatch?.groups) {
    return translate.t("validations.invalidMarkdown.tag", {
      tag: tagMatch.groups.tag,
    });
  }

  return translate.t("validations.invalidMarkdown.default");
};

export { getErrorMessage };
